class AppSelectOption {
  constructor(label, value, isLabelKey = true) {
    this.label = label;
    this.value = value;
    this.isLabelKey = isLabelKey;
  }
}

export { AppSelectOption };
